export enum AuthKeys {
  INFO_TOKEN = 'if-token',
  INFO_USER = 'if-user',
  LW_TOKEN = 'lw-token',
  LW_USER = 'lw-user',
  MUST_CHANGE_PASSWORD = 'must-change-password',
}
